import Note from "./note"
import Collection from "../../data-structures/collection"

const debug = false
// const debug = "Notes"

export default class Notes extends Collection<Note> {

    // public models: Note[]

    constructor(models:Note[]) {
        super(models)
    }

    static initFromJson(data:JSONArray) {
        const collection = new Notes([])

        _.map(data, (record:JSONObject)=>{
            collection.add(new Note(record))
        })

        collection.sort()

        return collection
    }

    add(model: Note) {
        super.add(model)

        this.sort()
    }

    generateNewName() {
        if (this.models.length < 1) return "Notes"
        else return "Notes "+ (this.models.length + 1)
    }

    sort = () => {
        this.models = _.orderBy(this.models, [
            model=>model.access === gd.const.meeting.noteAccess.PRIVATE,
            model=>model.momentCreated?.format('x')
        ], ['desc','asc'])
    }
}